import type { ResumeDto } from "@stylingcv/dto";
import { useQuery } from "@tanstack/react-query";
import type { AxiosResponse } from "axios";

import { RESUMES_KEY } from "@/client/constants/query-keys";
import { axios } from "@/client/libs/axios";
import { useAuthStore } from "@/client/stores/auth";

export const fetchResumes = async () => {
  try {
    const response = await axios.get<ResumeDto[], AxiosResponse<ResumeDto[]>>("/resume");
    return response.data;
  } catch (error: any) {
    const status = error?.response?.status || error?.status;
    if (status === 401 || status === 403) {
      // Guests are expected to receive auth errors here.
      return [];
    }
    throw error;
  }
};

export const useResumes = () => {
  const user = useAuthStore((state) => state.user);
  const isAuthenticated = !!user;

  const {
    error,
    isPending: loading,
    data: resumes,
  } = useQuery({
    queryKey: RESUMES_KEY,
    queryFn: fetchResumes,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
  });

  // When no authenticated user is present, don't expose a loading state.
  const resolvedLoading = isAuthenticated ? loading : false;

  return { resumes, loading: resolvedLoading, error };
};
